import appSettings from 'wanderu-config';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import {
    getInterlinkC2CData,
} from 'wanderu-service-wapi';

import {
    setInterlinkC2CData,
} from '../../appstate/actions';
import DUCK_NAMESPACE from '../../types';

const NAMESPACE = 'ACTIONS/FETCH_C2C_INTERLINKS';

const logger = Logger.getLogger('wanderu-ducks-seo');

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(NAMESPACE, DUCK_NAMESPACE);

function fetchCityToCityInterlinks(id, params = {}) {
    const {
        fromCity,
        fromRegion,
        locale,
        mode,
        toCity,
        toRegion,
    } = params;

    if (!fromCity || !fromRegion
        || !toCity || !toRegion
        || !mode || !locale) {
        throw new Error('missing required params');
    }

    return async (dispatch) => {
        let error = null;

        dispatch(actions.startWork(id));

        try {
            const { result } = await getInterlinkC2CData({
                fromCity,
                fromRegion,
                locale,
                mode,
                toCity,
                toRegion,
            });

            return dispatch(setInterlinkC2CData(id, result));
        } catch (ex) {
            if (ex.code !== 'C2C_LINKS_NOT_FOUND') {
                const domainUserInfo = appSettings.env.isClient
                    ? SnowplowService.getDomainUserInfo()
                    : {};

                logger.error('fetchCityToCityInterlinks', ex, {
                    snowplowIds: {
                        networkUserId: SnowplowService.getNetworkUserId(),
                        ...domainUserInfo,
                    },
                });
            }

            error = ex;
        } finally {
            dispatch(actions.endWork(id, undefined, error));
        }
    };
}

function selectNotFound(appState, id) {
    const opStatus = selectors.idSelector(appState, id);

    return opStatus && !opStatus.working
        && !!opStatus.error
        && opStatus.error.code === 'INVALID_CITY_TO_CITY';
}

const fetchCityToCityInterlinksAction = {
    fetchCityToCityInterlinks,
    ...selectors,
    selectNotFound,
};

export {
    fetchCityToCityInterlinksAction,
    NAMESPACE as namespace,
};
export default {
    [NAMESPACE]: reducer,
};
